export const SkillsData = {
    data: [
        {
            title: 'Python',
            description: 'Flask is a small and lightweight Python web framework that provides useful tools and features that make creating web applications in Python easier.',
            links: ['https://python.org', 'https://flask.palletsprojects.com/en/2.1.x/'],
            tags: [{ title: 'python', link: 'https://python.org' }, { title: 'flask', link: 'https://flask.palletsprojects.com/en/2.1.x/' }]
        },
        {
            title: 'HTML & CSS',
            description: 'HTML (the Hypertext Markup Language) and CSS (Cascading Style Sheets) are two of the core technologies for building Web pages. HTML provides the structure of the page, CSS the (visual and aural) layout, for a variety of devices.',
            links: ['https://www.w3schools.com/html/', 'https://www.w3schools.com/css/'],
            tags: [{ title: 'HTML', link: 'https://www.w3schools.com/html/' }, { title: 'CSS', link: 'https://www.w3schools.com/css/' }, { title: 'SASS', link: 'https://www.w3schools.com/css/' }, { title: 'SCSS', link: 'https://www.w3schools.com/css/' }]
        },
        {
            title: 'CSS Frameworks',
            description: 'A CSS framework is a library allowing for easier, more standards-compliant web design using the Cascading Style Sheets language. Bootstrap, FluentUI, Bulma, Materialize, Mantine, Antd, Prime',
            links: ['https://getbootstrap.com/', 'https://developer.microsoft.com/en-us/fluentui', 'https://bulma.io/', 'https://materializecss.com/', 'https://mantine.dev/', 'https://ant.design/', 'https://www.primefaces.org/'],
            tags: [
                { title: 'bootstrap', link: 'https://getbootstrap.com/' },
                { title: 'fluentUI', link: 'https://developer.microsoft.com/en-us/fluentui' },
                { title: 'bulma', link: 'https://bulma.io/' },
                { title: 'materialize', link: 'https://materializecss.com/' },
                { title: 'mantine', link: 'https://mantine.dev/' },
                { title: 'antd', link: 'https://ant.design/' },
                { title: 'prime', link: 'https://www.primefaces.org/' }
            ]
        },
        {
            title: 'C#',
            description: 'C# is often used to develop professional, dynamic websites on the . NET platform, or open-source software.',
            links: ['https://www.w3schools.com/cs/index.php', 'https://docs.microsoft.com/en-us/dotnet/csharp/'],
            tags: [
                { title: 'c#', link: 'https://www.w3schools.com/cs/index.php' },
                { title: 'csharp', link: 'https://docs.microsoft.com/en-us/dotnet/csharp/' },
            ]
        },
        {
            title: 'React',
            description: 'React (also known as React.js or ReactJS) is a free and open-source front-end JavaScript library for building user interfaces based on UI components.',
            links: ['https://reactjs.org/'],
            tags: [
                { title: 'react', link: 'https://reactjs.org/' },
                { title: 'reactjs', link: 'https://reactjs.org/' },
                { title: 'react.js', link: 'https://reactjs.org/' }
            ]
        },
        {
            title: 'JavaScript',
            description: 'JavaScript (JS) is a lightweight, interpreted, or just-in-time compiled programming language with first-class functions. While it is most well-known as the scripting language for Web pages, many non-browser environments also use it, such as Node.js, Apache CouchDB and Adobe Acrobat.',
            links: ['https://developer.mozilla.org/en-US/docs/Web/JavaScript', 'https://www.w3schools.com/nodejs/nodejs_intro.asp', 'https://www.w3schools.com/js/'],
            tags: [
                { title: 'nodejs', link: '' },
                { title: 'typescript', link: '' },
                { title: 'react', link: '' },
                { title: 'javascript', link: '' },
            ]
        },
        {
            title: 'Microsoft 365',
            description: 'Microsoft 365 is the productivity cloud designed to help you pursue your passion and run your business. More than just apps like Word, Excel, PowerPoint, Microsoft 365 brings together best-in-class productivity apps with powerful cloud services, device management, and advanced security in one, connected experience.',
            links: ['https://www.microsoft.com/en/microsoft-365', 'https://www.office.com/'],
            tags: [
                { title: 'microsoft365', link: 'https://www.microsoft.com/en/microsoft-365' },
                { title: 'office365', link: 'https://www.microsoft.com/en/microsoft-365' },
                { title: 'o365', link: 'https://www.microsoft.com/en/microsoft-365' }
            ]
        },
        {
            title: 'Microsoft Power Platform',
            description: 'Power Platform combines the robust power of Power Apps, Power BI, Power Automate, and Power Virtual Agents into one powerful business application platform – providing quick and easy app building and data insights.',
            links: ['https://powerplatform.microsoft.com/en-us/'],
            tags: [
                { title: 'power apps', link: 'https://powerapps.microsoft.com/en-au/' },
                { title: 'power bi', link: 'https://powerbi.microsoft.com/en-au/' },
                { title: 'power automate', link: 'https://flow.microsoft.com/' },
                { title: 'power virtual agents', link: 'https://powervirtualagents.microsoft.com/en-us/' }
            ]
        },
        {
            title: 'Adobe Creative Suite',
            description: 'Adobe Creative Suite includes video, photo, design software and more.',
            links: ['https://www.adobe.com/'],
            tags: [
                { title: 'creative cloud', link: 'https://www.adobe.com/' },
                { title: 'adobe creative cloud', link: 'https://www.adobe.com/' },
            ]
        }
    ]
}
